import React, { useEffect, useState, useContext } from "react";

function Modal(props) {

    const toggleModal = props.toggleModal;
    const closeable = props.closeable ?? true;
    const onClickBackground = closeable ? toggleModal : () => { };
    const backgroudnCssClass = props.backgroundColor == "dark" ? "modal-backdrop dark" : "modal-backdrop";

    return (
        <div>
            {props.isOpen && (
                <div className={backgroudnCssClass} onClick={onClickBackground}>
                    <div onClick={e => e.stopPropagation()}>
                        {props.children}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Modal;